import { Component, OnInit } from '@angular/core';
import { OtSessionService } from '../ot-session.service';
import { OtEventService } from '../ot-event.service';
import { OtEvent, City } from 'src/app/domain/ot-event';
import { environment } from '../../../environments/environment';
import { Router, ActivatedRoute } from '@angular/router';
import { ReCaptcha2Component } from 'ngx-captcha';
import { RegistrationService, L10nService, MessageService } from '../../shared';
import { OtCityService } from '../ot-city.service';

@Component({
  selector: 'app-ot-registration-summary',
  templateUrl: './ot-registration-summary.component.html',
  styleUrls: ['./ot-registration-summary.component.scss']
})
export class OtRegistrationSummaryComponent implements OnInit {

  public registration: any;
  public otEvent: OtEvent;
  public environment: any;
  public recaptchaValue: any;

  private cityId: number;
  private otEventId: number;

  public city: City;

  public submitted = false;

  constructor(
      private otSessionService: OtSessionService,
      private otEventService: OtEventService,
      private registrationService: RegistrationService,
      private l10nService: L10nService,
      private messageService: MessageService,
      private cityService: OtCityService,
      private router: Router,
      route: ActivatedRoute) {
    this.environment = environment;

    this.cityId = Number.parseInt(route.snapshot.paramMap.get('cityId'), 10);
    this.otEventId = Number.parseInt(route.snapshot.paramMap.get('otEventId'), 10);
  }

  ngOnInit() {
    this.registration = this.otSessionService.getRegistration();

    if (! this.registration) {
      console.error('There was no registration saved');
      this.router.navigateByUrl('/city/' + this.cityId + '/ot/event/list');
      return;
    }

    this.cityService.getById(this.cityId).then(city => {
      this.city = city;
    });

    this.otEventService.getOtEventInfoById(this.registration.otEventId).then(otEventInfo => {
      this.otEvent = otEventInfo.otEvent;
    });
  }

  public onRecaptchaExpired(recaptcha: ReCaptcha2Component): void {
    recaptcha.resetCaptcha();
  }

  public goToNextStep(isFormValid: boolean, recaptcha?: ReCaptcha2Component): void {
    this.submitted = true;

    if (! isFormValid) {
      if (recaptcha) {
        recaptcha.resetCaptcha();
      }
      return;
    }

    const registration = Object.assign({}, this.registration);
    registration.person = Object.assign({}, registration.person);

    this.registrationService.create(registration, this.recaptchaValue).then(createdRegistration => {
      this.otSessionService.setRegistration(null);
      this.registrationService.afterRegistrationCreated(createdRegistration, this.cityId);
    }).catch(errorResponse => {
      if (recaptcha) {
        recaptcha.resetCaptcha();
      }
      if (errorResponse.status >= 500) {
        this.messageService.error(this.l10nService.get('finishing_serverError', [this.otEvent.organization.email]));
      }
    });
  }
}
